/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
const n={danger:"exclamation-mark-circle",info:"information",success:"check",warning:"exclamation-mark-triangle",brand:void 0,neutral:void 0,inverse:void 0};export{n as iconByKind};
